// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".save-button[data-v-4126d6c0]{text-align:center;width:1.2rem}[data-v-4126d6c0] .multisig_ban_container{padding-left:.7rem}", ""]);
// Exports
module.exports = exports;
